// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"InlineHtml_wrapper__1zEWh","paddingHorizontalNone":"InlineHtml_paddingHorizontalNone__34HAr"};